import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { apiUrl, isAdminLoggedIn } from "../../../ApiUrlAndToken";
import GeneralInput from "../../../components/GeneralInput";
import GeneralSelect from "../../../components/GeneralSelect";
import { submitButton } from "../../../components/DesignStandardize";
import { useSelector } from "react-redux";

const ProjectAdd = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [total_amount, setTotalAmount] = useState("");
  const [contact_amount, setContactAmount] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");
  const [business_partner, setBusinessPartner] = useState("");
  const [file, setFile] = useState(null); // State to store the selected file
  const [business_partners, setBusinessPartners] = useState([]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/businesspartner/`, {
          headers: {
            Authorization: `Bearer ${isAdminLoggedIn && jwt_token}`,
          },
        });
        const retrived = response.data;
        setBusinessPartners(
          retrived.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );

        console.log(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchGroups();
  }, []);

  const ProjectStatus = [
    { value: "upcoming", label: "Upcoming" },
    { value: "ongoing", label: "Ongoing" },
    { value: "complete", label: "Completed" },
  ];

  const jwt_token = useSelector((state) => state.global.jwt_token);

  const AddProjects = async (e) => {
    e.preventDefault();
    let statusValue;

    if (statusValue === -1) {
      toast.error("Invalid project status");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("total_amount", total_amount);

    formData.append("contact_amount", contact_amount);
    formData.append("status", selectedStatus);
    formData.append("business_partner", business_partner);
    if (file) {
      formData.append("picture", file); // 'Upload' matches the server's expected field name
    }

    try {
      const response = await axios.post(`${apiUrl}/api/project/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${isAdminLoggedIn && jwt_token}`,
        },
      });
      toast.success("Project Added Successfully!");
      console.log(response);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.log(error);
      if (error.response) {
        toast.error(`${error.response.data.message}`);
      } else if (error.request) {
        toast.error("No response received from the server");
      } else {
        toast.error("An error occurred while processing the request");
      }
    }
  };

  return (
    <div className="p-1 w-full flex flex-col gap-3 min-h-max max-h-[480px] overflow-y-auto mt-auto md:mr-auto font-semibold font-Inter text-sm text-left md:text-base">
      <div className="flex w-full flex-col md:flex-row gap-6 justify-center ">
        {/*  */}
        <div className="flex w-auto flex-col gap-3">
          <GeneralInput
            label="Project Name"
            type="text"
            placeholder="Enter Project Name"
            value={name}
            required
            className={""}
            onChange={(e) => setName(e.target.value)}
          />
          <GeneralSelect
            options={business_partners}
            label="Select Partner" // Corrected from 'lable' to 'label'
            placeholder="Select Partner"
            onChange={(selectedOption) =>
              setBusinessPartner(selectedOption.value)
            }
            value={
              business_partners.find(
                (option) => option.value === business_partner
              ) || ""
            }
          />

          <GeneralSelect
            options={ProjectStatus}
            label="Select Project Status" // Corrected from 'lable' to 'label'
            placeholder="Status"
            onChange={(selectedOption) =>
              setSelectedStatus(selectedOption.value)
            }
            value={
              ProjectStatus.find((option) => option.value === selectedStatus) ||
              ""
            }
          />
          <GeneralInput
            label="Contact Amount"
            type="number"
            min={1}
            value={contact_amount}
            onChange={(e) => setContactAmount(e.target.value)}
          />
        </div>

        {/*  */}
        <div className="flex w-auto flex-col gap-3">
          <GeneralInput
            label="Add Image"
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
          />
          <GeneralInput
            label="Project Details"
            type="textarea"
            placeholder="Enter Project Details"
            value={description}
            required
            onChange={(e) => setDescription(e.target.value)}
          />
          <GeneralInput
            label="Total Amount"
            type="number"
            min={1}
            value={total_amount}
            onChange={(e) => setTotalAmount(e.target.value)}
          />

          {/* <GeneralInput
            label="Project Location"
            type="textarea"
            placeholder="Enter Project Location"
            value={location}
            required
            onChange={(e) => setLocation(e.target.value)}
          /> */}

          {/* <div>
            <GeneralInput
              label="Scope of Work"
              type="text"
              value={sow}
              onChange={(e) => setSow(e.target.value)}
              placeholder="Enter Scope of Work"
              addItems={1}
              buttonFuntion={handleClick}
              className={""}
            />
            <p className="text-sm my-1 text-slate-500 font-normal mx-1">
              Press Enter or + button
            </p>
            {itemsOfSow.length > 0 && (
              <ul
                className={`flex flex-row flex-wrap gap-1 w-[320px] h-auto bg-[#c4c4ec] -mt-7 pt-8 pb-3 px-3 py-4 rounded-b`}
              >
                {itemsOfSow.map((item, index) => (
                  <li
                    key={index}
                    className="bg-white text-black rounded-xl px-2 ring-1 font-normal"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div> */}
        </div>
      </div>

      <button
        className={`${submitButton} mt-3 mx-auto`}
        type="submit"
        onClick={AddProjects}
      >
        Submit
      </button>
    </div>
  );
};

export default ProjectAdd;
